import { successfulAction } from '@shared/actions';
import { IS_NEW_ADDRESS } from '@commons/models/LocationPoint/model';
import { CREATE_ADDRESS } from '../actionTypes';

export const type = CREATE_ADDRESS;
export const errorMessage = 'Ocurrió un error al agregar su dirección.';
export const successMessage = 'Dirección agregada correctamente';

// eslint-disable-next-line no-unused-vars
const validateNewAddress = address => async (dispatch, _) => {
  if (!address?.isNewAddress) return;

  dispatch(
    successfulAction({
      type,
      payload: { ...address, [IS_NEW_ADDRESS]: true },
      message: successMessage,
    }),
  );
};

export default validateNewAddress;
